import Velocity from './libs/velocity.min.js'
import imagesloaded from './libs/imagesloaded.pkgd.min.js'

window.Velocity = Velocity
window.imagesLoaded = imagesloaded